import { FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';
import { item as TrackingItem } from 'c9-tracking';
import { trackInfo } from './common/tracking';
import { getElementFromElementType } from '../helpers/getElementFromElementType';
import { Field } from '../types/fields';
import { trackUpload } from './common/upload.utils';

/**
 * Tracking of user decision by upload
 */

export const trackFormBySubmit = async (formConfig: FormConfig, formValues: FormValues) => {
    let trackingItems: TrackingItem[] = [];

    const uploadElement: Field | undefined = getElementFromElementType(formConfig, 'uploadDocumentation');

    if (uploadElement !== undefined) {
        trackingItems = trackingItems.concat(trackUpload(formConfig, formValues, uploadElement.elementId));
    }

    if (trackingItems.length > 0) {
        trackInfo(formConfig, trackingItems);
    }
};
